import React from 'react'

const Tiff = ({ viewBox }) => (
  <svg viewBox={viewBox}>
    <path
      fill="#E9E9E0"
      d="M37.463,0H6.612C5.753,0,5.057,0.697,5.057,2.048v56.417c0,0.366,0.696,1.062,1.555,1.062h42.599
	c0.858,0,1.556-0.696,1.556-1.062V13.796c0-0.74-0.1-0.978-0.273-1.154L38.124,0.273C37.948,0.098,37.71,0,37.463,0z"
    />
    <path
      fill="#5889C4"
      d="M49.211,59.528H6.612c-0.859,0-1.555-0.696-1.555-1.555V41.457h45.709v16.516
	C50.767,58.831,50.069,59.528,49.211,59.528z"
    />
    <path
      fill="#C8BDB8"
      d="M39.491,11.866c-0.492-0.319-1.149-0.181-1.471,0.31c-1.523,2.334-4.23,5.489-5.517,6.777l-2.963,2.963
	l-3.006-3.006l2.962-2.965c1.882-1.882,6.666-5.784,8.627-6.486c0.042-0.007,0.097-0.016,0.118-0.021
	c0.555-0.125,0.88-0.656,0.782-1.215c-0.1-0.559-0.655-0.941-1.215-0.866l-0.301,0.066c-2.593,0.865-7.927,5.43-9.516,7.021
	l-7.638,7.638c-0.101-0.004-0.202-0.015-0.304-0.015c-3.158,0-5.807,2.259-6.36,5.332l-0.115,0.078l-0.021,0.57
	c-0.036,1-0.32,4.306-2.491,4.833c-0.549,0.137-0.912,0.663-0.843,1.225l0.173,0.977h7.419h0.022l0,0l2.217-0.032
	c3.58,0,6.492-2.913,6.492-6.492c0-0.205-0.011-0.407-0.031-0.608l7.494-7.491c1.388-1.388,4.172-4.633,5.794-7.118
	C40.12,12.845,39.983,12.187,39.491,11.866z M20.051,32.921h-3.974l0.016,0.032h-1.766c0.943-1.426,1.234-3.229,1.322-4.3
	l0.087-0.536c0.227-2.239,2.081-3.927,4.316-3.927c0.128,0,0.25,0.026,0.376,0.039l0.178,0.022c1.111,0.142,2.079,0.697,2.763,1.5
	c0.062,0.073,0.126,0.144,0.181,0.221c0.087,0.117,0.166,0.241,0.241,0.367c0.053,0.09,0.103,0.183,0.15,0.276
	c0.067,0.134,0.132,0.27,0.186,0.412c0.031,0.084,0.055,0.174,0.081,0.262c0.048,0.156,0.097,0.312,0.128,0.478l0.005,0.027
	c0.043,0.249,0.077,0.501,0.077,0.761C24.418,30.962,22.459,32.921,20.051,32.921z M25.271,24.711
	c-0.007-0.009-0.014-0.018-0.021-0.027c-0.644-0.862-1.494-1.557-2.479-2.014l2.257-2.257l3.006,3.006l-2.202,2.2
	C25.671,25.301,25.482,24.997,25.271,24.711z"
    />
    <polygon fill="#D9D7CA" points="38.01,0.161 38.01,12.756 50.605,12.756 " />
    <path
      fill="#FFFFFF"
      d="M19.175,45.628v1.192h-3.198v9.519h-1.758v-9.519h-3.197v-1.192H19.175z"
    />
    <path
      fill="#FFFFFF"
      d="M29.123,46.95v3.371H33.6v1.192h-4.477v4.825h-1.772V45.628h6.699v1.322H29.123z"
    />
    <path
      fill="#FFFFFF"
      d="M38.748,46.95v3.371h4.477v1.192h-4.477v4.825h-1.772V45.628h6.7v1.322H38.748z"
    />
    <path fill="#FFFFFF" d="M23.55,56.339h-1.773V45.628h1.773V56.339z" />
  </svg>
)

export default Tiff



// WEBPACK FOOTER //
// ./src/components/Svg/tiff.js